import React, { useState } from "react";
import { Box } from "@mui/material";

import msIconDark from "../ms-symbollockup_signin_dark.svg";

export const msalLoginConfig = {
  msalInstance: null,
  msalConfig: null,
  loginApiRequest: null,
  isInitialized: false,
};

/**
 * Microsoft login button
 */
export default function MsLoginButton({ theme }) {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const appOrigin = (() => {
    try {
      return new URL(
        process.env.REACT_APP_MS_REDIRECT_URI || window.location.origin
      ).origin;
    } catch (error) {
      console.warn(
        "Invalid REACT_APP_MS_REDIRECT_URI, falling back to window.location.origin.",
        error
      );
      return window.location.origin;
    }
  })();

  const getSafeRedirectTarget = (redirect) => {
    if (!redirect) {
      return "/packets";
    }

    try {
      const parsed = new URL(redirect, appOrigin);
      if (parsed.origin !== appOrigin) {
        console.warn(
          `Rejected cross-origin redirect target "${redirect}".`
        );
        return "/packets";
      }
      if (parsed.pathname === "/login") {
        return "/packets";
      }
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch (error) {
      console.warn(
        `Failed to parse redirect target "${redirect}", falling back to /packets.`,
        error
      );
      return "/packets";
    }
  };

  const handleAzureLogin = async () => {
    if (isLoggingIn) {
      return;
    }

    try {
      if (!msalLoginConfig.msalInstance) return;
      setIsLoggingIn(true);

      const params = new URLSearchParams(window.location.search);
      const redirect = params.get("redirect");
      const safeTarget = getSafeRedirectTarget(redirect);

      await msalLoginConfig.msalInstance.loginRedirect({
        ...msalLoginConfig.loginApiRequest,
        redirectStartPage: `${appOrigin}${safeTarget}`,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <Box
      component="img"
      className="ms-button"
      src={msIconDark}
      alt="ms-sign-in-button"
      onClick={handleAzureLogin}
      width="216px"
      sx={{
        cursor: isLoggingIn ? "default" : "pointer",
        maxWidth: "216px",
        opacity: isLoggingIn ? 0.7 : 1,
        pointerEvents: isLoggingIn ? "none" : "auto",
      }}
    />
  );
}
